export const getDragItemType = (name: string) => `ARRAY_ITEM-${name}`
export const EMPTY_HOVER = 'ARRAY_EMPTY'
export const NAVIGATION_GAP = 4
